"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class Label extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.state = {
      active: false
    };
    this.handleMouseEnter = e => {
      const active = e.target.offsetWidth + 1 < e.target.scrollWidth;
      if (this.state.active !== active) {
        this.setState({
          active
        });
      }
    };
  }
  render() {
    const {
      text,
      children,
      className,
      additionNode,
      ...other
    } = this.props;
    return _react.default.createElement(_styles.LabelContainer, (0, _extends2.default)({
      className: className
    }, other), _react.default.createElement(_styles.Text, {
      onMouseEnter: this.handleMouseEnter
    }, text), additionNode, this.state.active && children);
  }
}
Label.defaultProps = {
  className: '',
  additionNode: null
};
var _default = exports.default = Label;